// extracted by mini-css-extract-plugin
module.exports = {"inner":"Textarea_inner__9SZRD","textarea":"Textarea_textarea__MWLk2","isError":"Textarea_isError__TqpCq","editable":"Textarea_editable__UGeUR"};